import uuid from 'react-native-uuid';

export function v4() {
  return uuid.v4() as string;
}
